var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "page-container" }, [
      _c("h3", [
        _c("label", { attrs: { for: "member_email" } }, [_vm._v("Subscribe")]),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "newsletter-form",
          attrs: {
            id: "revue-form",
            name: "revue-form",
            target: "_blank",
            action: "https://www.getrevue.co/profile/atrvasa/add_subscriber",
            method: "post",
          },
        },
        [
          _c("input", {
            staticClass: "newsletter-input",
            attrs: {
              id: "member_email",
              type: "email",
              name: "member[email]",
              required: "",
              placeholder: "Email address",
            },
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "button newsletter-button",
            attrs: {
              id: "member_submit",
              type: "submit",
              value: "Subscribe",
              name: "member[subscribe]",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    You can read the previous issues and listen to our podcast at "
        ),
        _c(
          "a",
          { attrs: { href: "https://blog.atrvasa.com", target: "_blank" } },
          [_vm._v("blog.atrvasa.com")]
        ),
        _vm._v(".\n  "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }